import locales from './currency-locales.json'

const localeAliases = {
	en_US: 'en',
	'en-US': 'en',
	ru_RU: 'ru',
	'ru-RU': 'ru'
}

const resolveLocale = (language) => {
	if (!language) {
		return 'en'
	}
	if (locales[language]) {
		return language
	}
	if (localeAliases[language]) {
		return localeAliases[language]
	}
	const short = language.split(/[-_]/)[0]
	return locales[short] ? short : 'en'
}

export const currenciesForDropDown = (language) => {
	const list = locales[resolveLocale(language)]
	return Object.keys(list).map((code) => {
		const item = list[code]
		return {
			value: code,
			label: `${item.name} (${item.code} / ${item.symbol})`
		}
	})
}
